import { render } from "./ChangePin.vue?vue&type=template&id=4933824e&scoped=true"
import script from "./ChangePin.vue?vue&type=script&lang=js"
export * from "./ChangePin.vue?vue&type=script&lang=js"

import "./ChangePin.vue?vue&type=style&index=0&id=4933824e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4933824e"]])

export default __exports__